import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmailThreadedRepliesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EmailThreadedReplies",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.64 19.87v-8.19c0-2.63 1.47-3.41 3.33-3.41h19.72c0-1.33-.71-1.96-2.88-1.96H5.09C3.39 6.31 2.01 7.7 2 9.4v10.7c-.03.93.69 1.7 1.61 1.74h.02v-1.96Zm4.53 5.82H26.9c1.71 0 3.1-1.39 3.1-3.1v-9.81c0-1.71-1.39-3.1-3.1-3.1H8.17c-1.71 0-3.1 1.39-3.1 3.1v9.81c0 1.71 1.39 3.1 3.1 3.1m.78-10.92a.85.85 0 0 1-.21-.56c0-.49.39-.9.88-.9.17 0 .34.04.48.14l6.24 5.56c.68.6 1.7.6 2.37 0l6.24-5.56a.89.89 0 0 1 1.48.67c0 .25-.11.5-.29.67l-3.1 2.76 3.16 3.03c.36.33.39.9.06 1.26-.17.19-.41.29-.66.29a.88.88 0 0 1-.64-.28l-3.25-3.15-1.83 1.6c-.65.58-1.49.89-2.36.89-.88 0-1.72-.31-2.38-.89l-1.78-1.6-3.24 3.17a.892.892 0 0 1-1.54-.61c-.01-.26.09-.51.28-.69l3.15-3.06-3.06-2.75Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.43 27.86H7.86c-1.89 0-3.43-1.54-3.43-3.43V11.86c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v12.57c0 1.89-1.54 3.43-3.43 3.43M7.86 10.71c-.63 0-1.14.51-1.14 1.14v12.57c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V11.85c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1 21c-.63 0-1.14-.51-1.14-1.14V7.29c0-1.89 1.54-3.43 3.43-3.43h20.57a1.14 1.14 0 1 1 0 2.28H3.29c-.63 0-1.14.51-1.14 1.14v12.57c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.14 20.62c-.22 0-.44-.06-.63-.19l-8-5.33c-.52-.35-.67-1.06-.32-1.59.35-.52 1.06-.67 1.59-.32l7.37 4.91 7.37-4.91a1.146 1.146 0 1 1 1.27 1.91l-8 5.33c-.19.13-.41.19-.63.19Z"
      })]
    })
  }));
};
EmailThreadedRepliesIcon.displayName = 'EmailThreadedRepliesIcon';